import { Link } from 'react-router-dom';

export default function Brand({ to = '/' }: { to?: string }) {
  return (
    <Link to={to} className="group flex shrink-0 items-center gap-2.5" aria-label="MakeMyPartner Home">
      <span
        aria-hidden
        className="brand-ring grid size-8.5 place-items-center rounded-xl p-[2px] shadow-sm transition-transform duration-300 group-hover:scale-105"
      >
        <span className="grid size-full place-items-center rounded-[10px] bg-white text-navy transition-colors group-hover:bg-transparent group-hover:text-white">
          <svg viewBox="0 0 24 24" className="size-4.5" fill="none" aria-hidden>
            <path
              d="M12 21s7-6 7-11a7 7 0 10-14 0c0 5 7 11 7 11z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="10" r="2.5" fill="currentColor" />
          </svg>
        </span>
      </span>
      <span className="text-[18px] font-extrabold tracking-tight text-navy">
        Make<span className="text-[#E6298A]">my</span>partner
      </span>
    </Link>
  );
}
